import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingColors, ERebrandingFonts } from 'helpers/constants';

export const useStyles = makeStyles(() => ({
  root: {
    fontFamily: ERebrandingFonts.OPENSANS,
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    color: ERebrandingColors.MAIN,
    borderColor: ERebrandingColors.LIGHT,
  },
}));
